import {
  SET_COOKIE_CONSENT,
  SET_DEVICE_TYPE,
  SET_MEASUREMENTS,
  SET_GA_USER_ID,
  SET_MOBILE_TYPE,
} from "@constants/action-types";

export const setDeviceType = (value) => ({
  type: SET_DEVICE_TYPE,
  value,
});
export const setMeasurements = (value) => ({
  type: SET_MEASUREMENTS,
  value,
});

export const setCookieConsent = (value) => ({
  type: SET_COOKIE_CONSENT,
  value,
});

export const setGAUserId = (value) => ({
  type: SET_GA_USER_ID,
  value,
});

export const setMobileType = (value) => ({
  type: SET_MOBILE_TYPE,
  value,
});
